document.addEventListener('click', e => {
  const li = e.target.closest('.comparison-prod-variant--swatch > ol > li');
  if (!li) return;

  const wrapper = li.closest('.comparison-prod-variant--swatch');
  const info = li.closest('.comparison-prod-info');
  const variantId = li.querySelector('label')?.dataset.variid;

  wrapper.querySelector('.checked')?.classList.remove('checked');
  li.classList.add('checked');

  info.querySelector('.product-variant-id').value = variantId;
  info.querySelector('.checkout-btn').href = `/cart/${variantId}:1?checkout`;
});


document.querySelectorAll('.comparison-prod-selectbox select').forEach(select => {
  select.addEventListener('change', ({ currentTarget }) => {
    const parent = currentTarget.closest('.comparison-prod-list');
    const value = currentTarget.value;

    parent.querySelector('.comparison-prod-item.active')?.classList.remove('active');
    parent.querySelector(`.comparison-prod-item[data-id="${value}"]`)?.classList.add('active');

    parent.querySelectorAll('.comparison-prod-selectbox select').forEach(s => s.value = value);
  });
});